export declare namespace ParticipantSignatureModalTokenSections {
	interface ReasonLabel {
		color: string;
		fontSize: string;
		fontWeight: string;
	}
}

export type ParticipantSignatureModalTokens = {
	reasonLabel: ParticipantSignatureModalTokenSections.ReasonLabel;
};

export const reasonLabel: ParticipantSignatureModalTokenSections.ReasonLabel = {
	color: '{form.field.color}',
	fontSize: '14px',
	fontWeight: '600',
};

export default {
	reasonLabel,
} satisfies ParticipantSignatureModalTokens;
